import { Box, Button, Grid2, Typography, Snackbar, Alert, ToggleButton, ToggleButtonGroup, styled, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import axios from "axios";
import IntentsComponent from "./intents";
import { Link, useNavigate } from "react-router-dom";
import boaticon from './../assets/images/chartbot-bg.jpg'
import intentpages from './../assets/images/Chat-Agent-3.png'
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import OpenInBrowserIcon from '@mui/icons-material/OpenInBrowser';
import SettingsIcon from '@mui/icons-material/Settings';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    
    bgcolor: 'background.paper',

    boxShadow: 24,
    p: 4,
};

const InnerChartBot = () => {
    const navigate = useNavigate()
    const [listofchartboats, setlistofchartboats] = useState([])
    const [editID, seteditID] = useState()
    const [webisturl, setwebisturl] = useState()
    const [errormsg, seterrormsg] = useState()
    const [websitcontent, setwebsitcontent] = useState("")
    const [loader, setloader] = useState(false)
    const [startForm, setstartForm] = useState(false)
    const [documentStatus, setdocumentStatus] = useState(false)
    const [uploadLoader, setuploadLoader] = useState(false)
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarOpen2, setSnackbarOpen2] = useState(false);
    const [errormessage, seterrormessage] = useState("")
    const [deleteconfim, setdeleteconfim] = useState(false)
    const [onloaddatatodele, setonloaddatatodele] = useState({})
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search.slice(1));
    let obj = {};
    for (let pair of params.entries()) {
        obj[pair[0]] = pair[1];
    }
    const id = obj["id"];
    const type = obj["type"];
    const pagename = obj["pagename"];
    const [charCount, setcharCount] = useState();
    const [modeltrainsuccess, setmodeltrainsuccess] = useState(false)
    const [disableCountinu, setdisableCountinu] = useState(false)
    const GetChartboatsList = (id) => {
        setloader(false)
        axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("Admintoken")}` }
        if (type == "ADVANCED_WITH_KB") {
            axios.get(`/apiV1/web-page/?chatbot_id=${id}&is_active=true`).then((rep) => {
                setloader(true)
                setlistofchartboats(rep.data)
                let count = 0;
                rep.data.map((pages, i) => {
                    count += pages.content.length
                })
                setcharCount(count)
            }).catch((e) => {
                setloader(true)
            })
        }
    }


    const websitscrapingAI = () => {
        if (webisturl) {
            let req = {
                url: webisturl
            }
            axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("Admintoken")}` }
            axios.post(`apiV1/scrap-page/`, req).then((rep) => {
                setwebsitcontent(rep.data)
            }).catch((e) => {
                if (e.response.data.message) {
                    alert(e.response.data.message)
                }
            })
        } else {
            alert("Please enter valid website url")

        }
    }
    const saveWebsitepagesListData = (e) => {
        setSnackbarOpen2(false)
        seterrormsg("")

        if (webisturl && websitcontent) {
            let object = {
                content: websitcontent,
                chatbot: id,
            }
            if (!documentStatus) {
                object.url = webisturl
                object.type = "URL"
            } else {
                object.document_label = webisturl
                object.type = "DOCUMENT"
            }

            if (charCount > 100000) {
                setSnackbarOpen2(true)
                seterrormessage("Your content add limit exceeded")
                return false
            }
            axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("Admintoken")}` }
            setdisableCountinu(true)
            if (editID) {
                axios.patch(`apiV1/web-page/${editID}/`, object).then((rep) => {
                    GetChartboatsList(id);
                    setwebisturl("")
                    setwebsitcontent("")
                    seteditID("")
                    setstartForm(false)
                    //settypesofcharts(rep.data)
                }).catch((e) => {
                    if (e.response.data.detail) {
                        seterrormsg(e.response.data.detail)
                    }
                    if (e.response.data.message) {
                        alert(e.response.data.message)
                    }
                    if (e.response.data.url) {
                        seterrormsg(e.response.data.url[0])
                    }
                })
            } else {
                axios.post('apiV1/web-page/', object).then((rep) => {
                    GetChartboatsList(id);
                    setwebisturl("")
                    setwebsitcontent("")
                    setstartForm(false)
                    //settypesofcharts(rep.data)
                }).catch((e) => {
                    if (e.response.data.detail) {
                        seterrormsg(e.response.data.detail)
                    }
                    if (e.response.data.message) {
                        alert(e.response.data.message)
                    }
                    if (e.response.data.url) {
                        seterrormsg(e.response.data.url[0])
                    }
                })
            }
        } else {
            if (!documentStatus) {
                setSnackbarOpen2(true)
                seterrormessage("Please enter valid website url and website content")

            } else {
                setSnackbarOpen2(true)
                seterrormessage("Please enter valid document name and content")

            }
        }
    }
    const onchangepageContentEdit = (data) => {

        if (data.type == "DOCUMENT") {
            setdocumentStatus(true)
            setwebisturl(data.document_label)
        } else {
            setdocumentStatus(false)
            setwebisturl(data.url)
        }
        setwebsitcontent(data.content)
        seteditID(data.id)
        setstartForm(true)
    }
    const ondeletePageAndContent = () => {
        setdisableCountinu(false)
        
        axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("Admintoken")}` }
        axios.delete(`apiV1/web-page/${onloaddatatodele.id}/`).then((rep) => {
            if(listofchartboats.length == 1){
                trainchartboattoModal()
            }
            GetChartboatsList(id)

            setdeleteconfim(false)
            setstartForm(false)

        }).catch((e) => {
            if (e.response.data.message) {
                alert(e.response.data.message)
            }
        })
         
    }
    const changeDocumentToWebsit = (data) => {
        setdocumentStatus(data)
    }
    const AddnewPagesToWithKB = () => {
        setwebisturl('')
        setwebsitcontent("")
        seteditID("")
    }
    useEffect(() => {

        GetChartboatsList(id)
    }, [])
    const SelectionFileAndDocument = (event) => {

        setSnackbarOpen(false)

        if (event.target.files.length !== 0) {
            if (event.target.files[0]) {
                const allowedTypes = [
                    "application/pdf",
                    "application/msword",
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    "text/plain",
                    "application/vnd.ms-excel",
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                ];

                if (!allowedTypes.includes(event.target.files[0].type)) {
                    alert("Invalid file type. Only PDF, DOC, DOCX, TXT, XLS, and XLSX are allowed.");
                    document.getElementById("fileInput").value = "";
                    return;
                }

                console.log("File is valid:");
            }
            if (event.target.files[0].size > 25 * 1024 * 1024) {
                setSnackbarOpen(true)
                document.getElementById("fileInput").value = "";
                return false
            }
            setuploadLoader(true)
            let fromdata = new FormData()
            fromdata.append('document', event.target.files[0])

            axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("Admintoken")}` }
            axios.post('apiV1/extract-document/', fromdata).then((rep) => {
                setwebsitcontent(rep.data)
                document.getElementById("fileInput").value = "";
                setuploadLoader(false)
            }).catch((e) => {
                if (e.response.data.detail) {
                    seterrormsg(e.response.data.detail)
                }
                if (e.response.data.message) {
                    alert(e.response.data.message)
                }
                setuploadLoader(false)
            })
        }
    }

    const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
        fontSize: "0.875rem",
        padding: "6px 16px",
        borderRadius: "8px",
        "&.Mui-selected": {
            backgroundColor: "#3367d7",
            color: "#fff",
            fontWeight: "bold",
            "&:hover": {
                backgroundColor: theme.palette.primary.dark,
            },
        },
    }));
    const [trainLoader, settrainLoader] = useState(false)
    const trainchartboattoModal = () => {
        settrainLoader(true)
        let req = {
            chatbot_id: id,
            bot_type: type
        }
        axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("Admintoken")}` }
        axios.post(`/apiV1/train-knowledge-base/`, req).then((rep) => {
            settrainLoader(false)
            setmodeltrainsuccess(true);
            setdisableCountinu(false)
        }).catch((e) => {
            if (e.response.data.message) {
                alert(e.response.data.message)
            }
            settrainLoader(false)
        })
    }
    const ContinueIntents = () => {
        navigate(`/chartbotwithkbintent?id=${id}&type=${type}&pagename=${pagename}`)
    }
    return (

        <Grid2 container spacing={2}>
            {trainLoader ? <div className="screenLoader">
                <div className='text-center' style={{ marginTop: "10%" }}>
                    <div className='spinner-grow text-primary' role='status'>
                        <span className='sr-only'>Loading...</span>
                    </div>
                </div>
            </div> : ""}
            {type == "BASIC_WITHOUT_KB" ? <IntentsComponent id={id} type={type} pagename={pagename} /> : type == "ADVANCED_WITH_KB" ?
            <>
                <Grid2 size={{ xs: 12, md: 4, lg: 3 }} sx={{ mt: 2, }}>
                    <div className="card">
                        <div className="card-body minheightforviwe" >
                            <div className="d-flex flex-row gap-2">
                                {type == "ADVANCED_WITH_KB" ? <Link to={`/`} sx={{ marginTop: 1 }}  > <ArrowBackIcon /></Link> : ""}
                                <h5 className="mt-1">{pagename}</h5>
                            </div>


                            <button onClick={() => { AddnewPagesToWithKB(); setstartForm(true); seteditID(""); seterrormsg(""); setwebisturl(""); setwebsitcontent("") }}
                                className="position-relative d-inline-flex align-items-center greaditentbutton justify-content-center p-1  me-2 overflow-hidden text-sm fw-medium text-dark rounded-lg border-0"
                            > <span className="position-relative px-4 py-2  rounded-md" style={{ transition: "0.3s" }} > + Pages  </span>
                            </button>
                            {loader ? <div className="file-manager-menu">
                                <ul className="list-unstyled">
                                    {listofchartboats.map((intent, i) => {
                                        return (
                                            <li className={intent.id == editID ? "cursor-pointer d-flex active" : "cursor-pointer d-flex "} key={intent.id} onClick={() => onchangepageContentEdit(intent)}>
                                                <div className="intentsTitleShow"><i className="far fa-folder"></i> <small>{intent.type == "DOCUMENT" ? intent.document_label : intent.url}</small> </div>
                                                <Button sx={{ marginTop: "10px" }} className="positionremoveButton" onClick={() => {setdeleteconfim(true); setonloaddatatodele(intent)}} >
                                                    <CloseIcon sx={{ color: "gray", "&:hover": { color: "red" }, margin: '10px 10px' }} />
                                                </Button>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div> :
                            <div className='text-center' style={{ marginTop: "10%" }}>
                                <div className='spinner-grow text-primary' role='status'>
                                    <span className='sr-only'>Loading...</span>
                                </div>
                            </div>}
                            <div className="positionabs" style={{ width: "95%" }}>
                                <div>Characters {charCount}</div>
                                <button onClick={() => { trainchartboattoModal() }} disabled={listofchartboats.length == 0 ? true : false} style={{ background: "linear-gradient(to right,#22c55e, #06b6d4)" }}
                                    className="position-relative d-inline-flex align-items-center justify-content-center greaditentbutton p-1  me-2 overflow-hidden text-sm fw-medium text-dark rounded-lg border-0" >
                                    <span className="position-relative px-4 py-2 rounded-md d-flex align-items-center" style={{ transition: "0.3s", gap: "8px" }} >
                                        <SettingsIcon style={{ fontSize: "1.5rem" }} /> TRAIN KNOWLEDGE BASE
                                    </span>
                                </button>

                                <button
                                    onClick={() => { ContinueIntents() }} disabled={disableCountinu} title={disableCountinu ? "Please train the knowledbase before proceeding" :""}
                                    className="position-relative d-inline-flex align-items-center justify-content-center p-1  me-2 greaditentbutton overflow-hidden text-sm fw-medium text-dark rounded-lg border-0" >
                                    <span className="position-relative px-4 py-2 rounded-md d-flex align-items-center" style={{ transition: "0.3s", gap: "8px" }} >
                                        <OpenInBrowserIcon style={{ color: "white" }} />   {listofchartboats.length == 0 ? "SKIP FOR NOW" : "Continue Intents"} 
                                    </span>
                                </button>

                            </div>
                        </div>
                    </div>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 8, lg: 9 }} sx={{ mt: 2 }}>
                    <div className="card minheightforviwe">
                        <div className="card-body">

                            {startForm ?
                                <>
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                    >
                                        <ToggleButtonGroup
                                            value={documentStatus ? "website" : "document"}
                                            exclusive
                                            onChange={(e, newValue) => {
                                                if (newValue !== null) {
                                                    changeDocumentToWebsit(newValue === "website");
                                                }
                                            }}
                                            size="small"
                                        >
                                            <StyledToggleButton value="document">Website</StyledToggleButton>
                                            <StyledToggleButton value="website">Document</StyledToggleButton>
                                        </ToggleButtonGroup>
                                    </Box>
                                    <Box sx={{ '& .MuiTextField-root': { m: 1, } }} noValidate autoComplete="off" >
                                        <div>
                                            <div className="mb-3 text-left">
                                                <label for="outlined-required" className="form-label">{!documentStatus ? "Website Url" : "Document Name"}</label>
                                                <input type="text" className="form-control" id="outlined-required" value={webisturl} onChange={(e) => { setwebisturl(e.target.value); }} placeholder={!documentStatus ? "Website Url" : "Document Name"} />
                                            </div>
                                            <div className="mb-3 text-left">
                                                <label for="outlined-required2" className="form-label">{!documentStatus ? "Website Content" : "Document Content"} </label>


                                                {!documentStatus ?
                                                    <div className="website-scraping-ai" onClick={() => websitscrapingAI()}>
                                                        Website Scraping AI
                                                    </div> :
                                                    <div>
                                                        <label htmlFor="fileInput" className="clicktoUploadCss" >
                                                            <CloudUploadIcon color="primary" sx={{ fontSize: 50 }} />
                                                            <Typography variant="body1">  Click to Upload</Typography>
                                                        </label>
                                                        <input type="file" id="fileInput" hidden  accept=".pdf,.doc,.docx,.txt,.xlsx,.xls" disabled={uploadLoader} onChange={(e) => SelectionFileAndDocument(e)} />
                                                    </div>
                                                }

                                                {uploadLoader ? <div className='text-center' style={{ marginTop: "10%" }}>
                                                    <div className='spinner-grow text-primary' role='status'>
                                                        <span className='sr-only'>Loading...</span>
                                                    </div>
                                                </div> : ""}
                                                <textarea className="form-control" id="outlined-required2" aria-label="With textarea" rows={documentStatus ? 19 : 24} value={websitcontent} onChange={(e) => setwebsitcontent(e.target.value)} placeholder="Content"></textarea>

                                            </div>
                                            <div className="text-danger">{errormsg}</div>
                                        </div>
                                        <Box display="flex" justifyContent="space-between" alignItems="center" width="100%" sx={{ padding: "0px 0px" }}>
                                            <button type="submit"  onClick={() => saveWebsitepagesListData()} style={{ height: "40px", width: "initial" }}
                                                className="position-relative d-inline-flex align-items-center justify-content-center p-1  me-2 overflow-hidden text-sm greaditentbutton fw-medium text-dark rounded-lg border-0" >
                                                <span className="position-relative px-4 py-2  rounded-md" style={{ transition: "0.3s" }} > Save </span>
                                            </button>
                                            <button type="button" onClick={() => { setstartForm(false); seteditID(""); }} style={{ height: "40px", width: "initial", background: " linear-gradient(to right,rgb(233, 6, 6),rgb(240, 32, 49))" }}
                                                className="position-relative d-inline-flex align-items-center justify-content-center p-1  me-2 overflow-hidden text-sm greaditentbutton fw-medium text-dark rounded-lg border-0" >
                                                <span className="position-relative px-4 py-2  rounded-md" style={{ transition: "0.3s" }} > Cancel </span>
                                            </button>
                                        </Box>
                                    </Box>
                                </>
                                :
                                <Box textAlign={"center"}>
                                    <img src={intentpages} style={{ maxWidth: "100%",  margin: "10% auto" }} />
                                </Box>}
                        </div>
                    </div>

                </Grid2>
            </>
            : ""}
            <Snackbar open={snackbarOpen} autoHideDuration={5000} onClose={() => setSnackbarOpen(false)} anchorOrigin={{ vertical: "center", horizontal: "center" }} >
                <Alert onClose={() => setSnackbarOpen(false)} severity="error" className="AlertSuccessMUI" >
                    Please select less 25MB file to scrap
                </Alert>
            </Snackbar>
            <Snackbar open={snackbarOpen2} autoHideDuration={5000} onClose={() => setSnackbarOpen2(false)} anchorOrigin={{ vertical: "center", horizontal: "center" }} >
                <Alert onClose={() => setSnackbarOpen2(false)} severity="error" className="AlertSuccessMUI" >
                    {errormessage}
                </Alert>
            </Snackbar>
            <Snackbar open={modeltrainsuccess} autoHideDuration={6000} onClose={() => setmodeltrainsuccess(false)} anchorOrigin={{ vertical: "bottom", horizontal: "center" }} >
                <Alert onClose={() => setmodeltrainsuccess(false)} severity="success" className="AlertSuccessMUI"  >
                    Your chatbot has trained successfully!
                </Alert>
            </Snackbar>
            <Modal open={deleteconfim} onClose={() => setdeleteconfim(false)} aria-labelledby="parent-modal-title" aria-describedby="parent-modal-description" >
                    <Box sx={{ ...style,  }}>
                        <Grid2 container spacing={2} textAlign={"center"}>
                            <Grid2 size={12}>
                            Are you sure you want to delete page or document <br/> This action cannot be undone.
                                
                            </Grid2>
                        </Grid2>

                        <Grid2 container spacing={2} textAlign={"center"}>
                            <Grid2 size={12} sx={{ mt: 3 }} textAlign={"center"}>
                                <Button variant="contained" sx={{ mx: 2 }} color="error" onClick={() => ondeletePageAndContent()}>Delete</Button>
                                <Button variant="contained" onClick={() => { setdeleteconfim(false); GetChartboatsList(id); }}>Cancel</Button>
                            </Grid2>
                        </Grid2>
                    </Box>
                </Modal>
        </Grid2>
    )
}
export default InnerChartBot;